import React from 'react';
import { ArrowRightIcon, PlayIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
type WhyRunningProps = {
  onWatch: () => void;
};
export function WhyRunning({
  onWatch
}: WhyRunningProps) {
  return <section aria-labelledby="why-heading" className="bg-ink py-16 sm:py-20 lg:py-28" data-id="element-455" data-mp="36x5l3p5ylp3r">
      <div className="mx-auto grid max-w-content gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:items-center lg:gap-14 lg:px-10" data-id="element-456" data-mp="3btduelxh6o30">
        <Reveal className="lg:col-span-5" data-id="element-457" data-mp="2f6990qrq3ohj">
          <p className="flex items-center gap-2.5 text-[13px] font-semibold text-gold-400" data-id="element-458" data-mp="2j6jcnws1m2t8">
            <span aria-hidden className="h-px w-6 bg-current opacity-60" data-id="element-459" data-mp="2o4bebiihp3am" />
            Why I am running
          </p>
          <h2 id="why-heading" className="mt-3 font-display text-[30px] leading-[1.1] tracking-[-0.02em] text-white sm:text-[38px] lg:text-[42px]" data-id="element-460" data-mp="2t4h1aldte1md">
            “We have run out of patience with promises. So have I.”
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-white/70" data-id="element-461" data-mp="k70bwjk45yhj">
            A twelve-minute message on what I saw governing a broke state, what it taught me about
            delivery, and the standard I am asking Nigerians to hold this campaign to.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4" data-id="element-462" data-mp="b7n21ps2v7wa">
            <Button size="lg" onClick={onWatch} data-id="element-463" data-mp="667e9pyimna7">
              Watch the message
            </Button>
            <Button variant="tertiary" onDark data-id="element-464" data-mp="1977fctudgi1">
              Read the transcript
              <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-465" data-mp="3sl8v510qxcx1" />
            </Button>
          </div>
        </Reveal>

        <Reveal delay={0.06} className="lg:col-span-7" data-id="element-466" data-mp="3ol85slc3zhb7">
          <button type="button" onClick={onWatch} aria-label="Play the campaign message video" className="group relative block w-full overflow-hidden rounded-media" data-id="element-467" data-mp="3jm5cfy5hqzj2">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg" alt="Supporters at a campaign town hall in Abuja" loading="lazy" className="aspect-video w-full object-cover transition-transform duration-300 ease-emphasis group-hover:scale-[1.02]" data-id="element-468" data-mp="39oqx61vb0gsc" />
            <span aria-hidden className="absolute inset-0 bg-ink/35" data-id="element-469" data-mp="2v07eor9cclki" />
            <span className="absolute inset-0 flex items-center justify-center" data-id="element-470" data-mp="2v2k39n9ltu6j">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-ink transition-colors duration-150 ease-emphasis group-hover:bg-gold-400" data-id="element-471" data-mp="3isegw71qzmru">
                <PlayIcon aria-hidden className="ml-1 h-6 w-6 fill-current" data-id="element-472" data-mp="39xhz4q3yp1sd" />
              </span>
            </span>
            <span className="absolute bottom-4 left-4 rounded bg-ink/80 px-3 py-1.5 text-[12px] font-semibold text-white" data-id="element-473" data-mp="3dxs0fpgt740w">
              12:04 · Captions &amp; transcript available
            </span>
          </button>
        </Reveal>
      </div>
    </section>;
}